// Password policy shared by the two places where a password is set:
// - pages/ResetPassword.vue (OTP flow, /auth/reset_password)
// - pages/SetPassword.vue   (magiclink flow, /auth/magiclink/validate)
// Kept as pure functions so it can be unit-tested without mounting a page.

export const PASSWORD_RULES = [
  { key: 'minLength', labelKey: 'login.passwordRequirementMinLength' },
  { key: 'uppercase', labelKey: 'login.passwordRequirementUppercase' },
  { key: 'lowercase', labelKey: 'login.passwordRequirementLowercase' },
  { key: 'digit', labelKey: 'login.passwordRequirementDigit' },
  { key: 'letter', labelKey: 'login.passwordRequirementLetter' },
  { key: 'specialChar', labelKey: 'login.passwordRequirementSpecialChar' }
]

const VALIDATORS = {
  minLength: (password) => password.length >= 8,
  uppercase: (password) => /[A-Z]/.test(password),
  lowercase: (password) => /[a-z]/.test(password),
  digit: (password) => /[0-9]/.test(password),
  letter: (password) => /[A-Za-z]/.test(password),
  specialChar: (password) => /[^A-Za-z0-9\s]/.test(password)
}

// Returns [{ key, labelKey, valid }] in display order.
export function checkPassword(password) {
  const value = password || ''
  return PASSWORD_RULES.map((rule) => ({
    ...rule,
    valid: VALIDATORS[rule.key](value)
  }))
}

export function isPasswordValid(password) {
  return checkPassword(password).every((requirement) => requirement.valid)
}
